<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1825.1 935.8"
  >
    <polygon
      points="1825.1 556.44 1792.29 603.8 254.09 798.3 253.81 779.76 253.72 779.2 565.56 735.05 565.6 734.74 650.79 722.68 650.79 722.69 665.5 720.6 947.06 680.73 1825.1 556.44"
      fill="#fff0cc"
    />
    <polygon
      points="1793.67 603.62 1729.22 696.62 1727.86 696.8 1792.29 603.8 1793.67 603.62"
      fill="#fff"
    />
    <polygon
      points="1792.29 603.8 1727.86 696.8 255.35 883 254.09 798.3 1792.29 603.8"
      fill="#f91c32"
    />
    <polygon
      points="1727.86 696.8 1562.24 935.8 256.13 935.8 255.35 883 1727.86 696.8"
      fill="#fff0cc"
    />
    <polygon
      points="1569.5 591.03 946.85 679.17 672.1 135.05 1569.5 591.03"
      fill="#45cff4"
    />
    <polygon
      points="946.85 679.17 946.85 679.19 826.11 696.27 946.85 679.17"
      fill="#27c9e9"
    />
    <polygon
      points="946.85 679.17 826.11 696.27 672.1 135.05 946.85 679.17"
      fill="#27c9e9"
    />
    <polygon
      points="672.1 135.05 672.1 719.31 665.5 720.6 665.44 0 672.1 0 672.1 135.05"
      fill="#b27839"
    />
    <polygon
      points="665.44 0 665.5 720.6 650.79 722.68 650.79 132 650.79 95.29 650.79 56.72 650.79 18.13 650.79 0 665.44 0"
      fill="#996e3c"
    />
    <polygon
      points="665.5 720.6 650.79 722.69 650.79 722.68 665.5 720.6"
      fill="#996e3c"
    />
    <polygon
      points="650.79 18.13 650.79 56.72 391.22 57.87 650.79 18.13"
      fill="#b20909"
    />
    <polygon
      points="650.79 56.72 650.79 95.29 391.22 57.87 650.79 56.72"
      fill="#ed0c0c"
    />
    <polygon
      points="650.79 132 565.6 734.74 217.65 784 650.79 132"
      fill="#45cff4"
    />
    <polygon
      points="650.79 132 217.65 784 150.31 793.53 650.79 132"
      fill="#27c9e9"
    />
    <polygon
      points="565.6 734.74 565.56 735.05 253.72 779.2 217.43 784.32 217.65 784 565.6 734.74"
      fill="#fff0cc"
    />
    <polygon
      points="255.35 883 256.13 935.8 0 935.8 0 915.3 255.35 883"
      fill="#e2d0ac"
    />
    <polygon
      points="254.09 798.3 255.35 883 0 915.3 0 830.43 254.09 798.3"
      fill="#ef1625"
    />
    <polygon
      points="253.81 779.76 254.09 798.3 0 830.43 0 814.81 150.31 793.53 150.06 793.87 217.43 784.32 253.72 779.2 253.81 779.76"
      fill="#e2d0ac"
    />
    <polygon
      points="217.65 784 217.43 784.32 150.06 793.87 150.31 793.53 217.65 784"
      fill="#27c9e9"
    />
    <path d="M942.68,273" transform="translate(-47.45 -83.03)" fill="#996e3c" />
  </svg>
</template>

<script setup></script>
